// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2J_oN","actionsCol":"EnrolledClinics_actionsCol__2h4Uj"};